export type WorkflowStyle = 'department' | 'trip';

export const workflowStyleName: Record<WorkflowStyle, string> = {
  department: '部署',
  trip: '旅程'
};
